// Import markdown files as strings
import offsetOvertimeMd from '../descriptions/offset_overtime.md?raw';
import fixedDollarMd from '../descriptions/fixed_dollar.md?raw';
import hourlyPremiumMd from '../descriptions/hourly_premium.md?raw';
import guaranteedRateMd from '../descriptions/guaranteed_rate.md?raw';

export const holidayMethodDescriptions = {
  guaranteed_rate: guaranteedRateMd,
  offset_overtime: offsetOvertimeMd,
  fixed_dollar: fixedDollarMd,
  hourly_premium: hourlyPremiumMd,
} as const;

export type HolidayMethodType = keyof typeof holidayMethodDescriptions;
